import { FC, PropsWithChildren } from "react";
import { SnackbarProvider as NotistackSnackbarProvider } from "notistack";

// All configuration should be defined here
const SnackbarProvider: FC<PropsWithChildren> = ({ children }) => (
  <NotistackSnackbarProvider variant="success" autoHideDuration={3000}>
    {children}
  </NotistackSnackbarProvider>
);

export default SnackbarProvider;
